import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';

export default function SavedIndicator({ savedAt }) {
  if (!savedAt) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        color: 'var(--color-active-fg)'
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 15 }} />
      <Typography
        variant="caption"
        sx={{ fontSize: '0.72rem', fontWeight: 700 }}
      >
        Saved just now
      </Typography>
    </Box>
  );
}
